import flowersImage from '../../images/family/flors-family.jpg';
import haschImage from '../../images/family/hasch-family.jpg';

// Modèle de navigation : une entrée peut ouvrir un méga-menu (`panel`) tout en restant
// elle-même un lien cliquable (comportement du header Ferrari).
export const navLinks = [
  {
    label: 'BOUTIQUE',
    value: '/shop',
    panel: {
      title: 'Notre sélection',
      text: `Des fleurs et des résines testées en laboratoire, toutes en dessous
        de 0,3% de THC, sélectionnées directement chez les producteurs.`,
      links: [
        { label: 'Toute la boutique', value: '/shop' },
        { label: 'Fleurs', value: '/shop/fleurs' },
        { label: 'Hasch', value: '/shop/hasch' }
      ],
      cards: [
        {
          label: 'Fleurs',
          caption: 'Indoor & greenhouse',
          value: '/shop/fleurs',
          image: flowersImage
        },
        {
          label: 'Hasch',
          caption: 'Résines & extractions',
          value: '/shop/hasch',
          image: haschImage
        }
      ]
    }
  },
  { label: 'FLEURS', value: '/shop/fleurs' },
  { label: 'HASCH', value: '/shop/hasch' },
  { label: 'LIVRAISON', value: '/delivery-infos' },
  { label: 'CONTACT', value: '/contact' }
];

export default navLinks;
